import React, { useState } from "react";
import { Container, Overline } from "@/components/common";
import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";

const TABS = [
  { key: "consultation", label: "Patient / Consultation", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "phone", label: "Phone" }, { name: "country", label: "Country" }, { name: "concern", label: "Area of Concern" }, { name: "message", label: "Message", area: true },
  ], upload: true },
  { key: "second_opinion", label: "Second Opinion", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "diagnosis", label: "Diagnosis", area: true }, { name: "main_question", label: "Main Question", area: true },
  ], upload: true },
  { key: "research", label: "Research Collaboration", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "organization", label: "Institution / Organization" }, { name: "subject", label: "Topic" }, { name: "message", label: "Message", area: true },
  ] },
  { key: "media", label: "Media Enquiry", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "organization", label: "Media Outlet" }, { name: "subject", label: "Subject" }, { name: "message", label: "Details", area: true },
  ] },
  { key: "speaking", label: "Speaking Engagement", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "organization", label: "Organization" }, { name: "subject", label: "Event / Topic" }, { name: "preferred_datetime", label: "Date" }, { name: "message", label: "Details", area: true },
  ] },
  { key: "ngo", label: "NGO / Social Impact", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "organization", label: "Organization" }, { name: "message", label: "How would you like to collaborate?", area: true },
  ] },
  { key: "mentorship", label: "Student / Mentorship", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "subject", label: "Area of Interest" }, { name: "message", label: "Message", area: true },
  ] },
  { key: "general", label: "General Enquiry", fields: [
    { name: "name", label: "Name", required: true }, { name: "email", label: "Email", type: "email", required: true },
    { name: "subject", label: "Subject" }, { name: "message", label: "Message", area: true },
  ] },
];

export default function Contact() {
  const [active, setActive] = useState(TABS[0].key);
  const tab = TABS.find((t) => t.key === active);
  return (
    <div data-testid="contact-page">
      <PageHero label="Contact" title="Get in Touch"
        intro="Choose the enquiry type that best fits your needs. Every submission reaches Dr. Sirohi's team directly."
        image="https://images.unsplash.com/photo-1496865534669-25ec2a3a0fd3?crop=entropy&cs=srgb&fm=jpg" />
      <section className="bg-white py-16">
        <Container>
          <div className="grid gap-12 md:grid-cols-12">
            <aside className="md:col-span-4">
              <Overline className="text-gold-dark">Enquiry Type</Overline>
              <div className="mt-4 flex flex-col gap-1">
                {TABS.map((t) => (
                  <button key={t.key} data-testid={`contact-tab-${t.key}`} onClick={() => setActive(t.key)}
                    className={`rounded-md px-4 py-3 text-left text-sm font-medium transition-colors ${active === t.key ? "bg-navy text-white" : "text-navy/70 hover:bg-softgrey"}`}>
                    {t.label}
                  </button>
                ))}
              </div>
            </aside>
            <div className="md:col-span-8">
              <h2 className="mb-6 font-serif text-3xl text-navy">{tab.label}</h2>
              <EnquiryForm key={tab.key} type={tab.key} allowUpload={!!tab.upload} fields={tab.fields} />
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
